import {createContext} from 'react';

import useDateSelect from './hooks/useDateSelect';

const DateSelectContext = createContext<ReturnType<typeof useDateSelect>>({
    currentFocus: undefined,
    disabled: undefined,
    error: undefined,
    id: '',
    isNextDisabled: false,
    isPreviousDisabled: false,
    maxDate: undefined,
    minDate: undefined,
    minuteStep: '15',
    onChangeZonedAtJst: () => {},
    onHide: () => {},
    onNext: () => {},
    onPrevious: () => {},
    onShow: () => {},
    refInput: {current: null},
    refPortal: {current: null},
    required: undefined,
    setCurrentFocus: () => {},
    show: false,
    showTime: false,
    valueZonedAtJst: undefined,
    visibleDateZonedAtJst: new Date(),
});

export default DateSelectContext;
